import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import { FormHelperText, Button, TextField } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { Helmet } from 'react-helmet'

import LogoImg from '../../commons/asset/Template_FullColor.png'
import { currentUserUpsert } from './actions'
import { ENTER_KEY } from '../../const/keyboard'
import { TEMPLATE_BLUE } from '../../const/color'
import sendRequest from '../../utils/api'

const SignInPublisher = ({ history }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errorLogin, setErrorLogin] = useState('')
  const dispatch = useDispatch()

  const handleLogin = async () => {
    if (email && password) {
      const result = await sendRequest({
        url: '/publisher/login',
        method: 'POST',
        data: { email, password },
        isPrivate: false,
      })
      result.data.isPublisher = true
      dispatch(currentUserUpsert.request(result.data))

      setTimeout(() => {
        history.push('/categories')
      }, 500)
    } else {
      setErrorLogin('Email and Password must be filled')
    }
  }

  return (
    <Wrapper>
      <Helmet>
        <title>Publisher Sign in | Template.net</title>
      </Helmet>

      <LoginForm>
        <Content>
          <img alt="logo" src={LogoImg} width="400px" />

          <Title>Publisher Login</Title>

          <TextField
            className="input"
            label="Email*"
            variant="outlined"
            value={email}
            onChange={event => setEmail(event.target.value)}
            onKeyDown={e => e.keyCode === ENTER_KEY && handleLogin()}
            fullWidth
          />

          <TextField
            className="input"
            type="password"
            label="Password*"
            variant="outlined"
            value={password}
            onChange={event => setPassword(event.target.value)}
            onKeyDown={e => e.keyCode === ENTER_KEY && handleLogin()}
            fullWidth
          />

          {errorLogin && (
            <FormHelperText style={{ color: '#b00020' }}>
              {errorLogin}
            </FormHelperText>
          )}

          <Button
            fullWidth
            variant="contained"
            style={{
              marginTop: 16,
              background: TEMPLATE_BLUE,
              color: 'white',
              padding: '15px 0',
            }}
            onClick={handleLogin}
          >
            Login
          </Button>
        </Content>
      </LoginForm>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100vh;
  background: #f5f5f5;
`

const LoginForm = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`

const Content = styled.form`
  width: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 80px 60px 80px;
  border-radius: 5px;
  background: white;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);

  .input {
    margin: 10px 0;
  }
`

const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
`

SignInPublisher.propTypes = {
  history: PropTypes.object,
}

export default withRouter(SignInPublisher)
